(function() {
  function debounce(fn, wait) {
    var timeout;
    return function() {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = window.setTimeout(function() {
        fn.apply(context, args);
      }, wait);
    };
  }

  function PredictiveSearch(root) {
    this.root = root;
    this.input = root.querySelector('[data-search-input]');
    this.results = root.querySelector('[data-predictive-search-results]');
    this.searchPath = root.getAttribute('data-search-path') || '/search/suggest';
    this.sectionId = root.getAttribute('data-search-section') || 'predictive-search';
    this.abortController = null;
    this.onInputChange = debounce(this.onInputChange.bind(this), 220);
    this.bindEvents();
  }

  PredictiveSearch.prototype.bindEvents = function() {
    if (!this.input || !this.results) return;

    this.input.addEventListener('input', this.onInputChange);
    this.input.addEventListener('focus', this.onFocus.bind(this));
    document.addEventListener('click', this.onDocumentClick.bind(this));
  };

  PredictiveSearch.prototype.onFocus = function() {
    if (this.results.innerHTML.trim() !== '') {
      this.openResults();
    }
  };

  PredictiveSearch.prototype.onDocumentClick = function(event) {
    if (!this.root.contains(event.target)) {
      this.closeResults();
    }
  };

  PredictiveSearch.prototype.onInputChange = function() {
    var term = this.input.value.trim();

    if (!term.length) {
      this.closeResults(true);
      return;
    }

    this.fetchResults(term);
  };

  PredictiveSearch.prototype.fetchResults = function(term) {
    var self = this;
    var params = new URLSearchParams();

    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();
    params.set('q', term);
    params.set('section_id', this.sectionId);
    params.set('resources[type]', 'product,page,article,query');
    params.set('resources[limit]', '8');
    params.set('resources[limit_scope]', 'all');

    fetch(this.searchPath + '?' + params.toString(), {
      signal: this.abortController.signal
    })
      .then(function(response) {
        return response.text();
      })
      .then(function(responseText) {
        var parser = new DOMParser();
        var html = parser.parseFromString(responseText, 'text/html');
        var section = html.querySelector('#shopify-section-' + self.sectionId);

        if (!section || !section.innerHTML.trim()) {
          self.closeResults(true);
          return;
        }

        self.results.innerHTML = section.innerHTML;
        self.openResults();
      })
      .catch(function(error) {
        if (error.name === 'AbortError') return;
        self.closeResults(true);
      });
  };

  PredictiveSearch.prototype.openResults = function() {
    this.results.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
  };

  PredictiveSearch.prototype.closeResults = function(clearMarkup) {
    this.results.hidden = true;
    this.input.setAttribute('aria-expanded', 'false');

    if (clearMarkup) {
      this.results.innerHTML = '';
    }
  };

  function initPredictiveSearch() {
    document.querySelectorAll('[data-predictive-search]').forEach(function(root) {
      if (!root.__predictiveSearch) {
        root.__predictiveSearch = new PredictiveSearch(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPredictiveSearch);
  } else {
    initPredictiveSearch();
  }
})();
